<template>
    <div styl="border-color:red">
            <b-row   class="d-none d-md-block" style="margin-top:20px;">
                <b-col>
                    <h4>Featured on Keg Seeker</h4>
                </b-col>
            </b-row>

            <b-row  v-if='nothingFound' >
                <b-col v-if='nothingFound' cols='10'><div class="inputwarning"><h4>Sorry, we didn't find any beers in your zip code</h4></div></b-col>
            </b-row>
            <br>

            <!--- Carousel with brewery logos. Don't show breweries which are part of distributors -->
            <b-row  class="d-none d-md-block"  style="margin-top:10px; margin-left:10px; margin-right:10px; background-color:#f2f2f2; height:270px">
                <b-col>
                    <carousel :perPageCustom="[[750, 3],[1070, 4], [1100, 10]]"  :mouse-drag="false" 
                    :autoplay="true" :loop="true" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" 
                    paginationColor="#fff">
                        <template  v-for="(brewer, index) in brewersList" >
                            <slide :key="index" v-if="brewer.logoFileThumbnailURL&&!brewer.distbrewerid">
                                <b-card style="width:110px; height:180px; margin-top:20px; cursor: pointer"   @click="viewBrewerProfile(brewer)">
                                    <div style="height:100px">
                                    <img  style="cmargin-left:0px" :src="brewer.logoFileThumbnailURL" width="75; height:75"  fluid alt="Logo image" >
                                    </div>
                                    <div style="border-bottom: 2px solid #f3d087 "></div>
                                    <div style="font-size:8px; text-align:center; padding-top:5px">{{brewer.company}}</div>
                                </b-card>
                            </slide>
                        </template>
                    </carousel>
                </b-col>
            </b-row>
            

            <b-row v-if='beersListLength' style="margin-top:10px;">
                <b-col>
                    <router-link to="createaccount" ><div style="margin-left:10px; font-size:20px">Join and get access to our growing selection:</div></router-link>
                </b-col>
            </b-row>

            <b-row v-if='beersListLength'  style="margin-top:10px; ">
                <b-col>
                    <beertable :everyAvailableBeer="beersList" :shouldShowSearch = 0 :shouldAllowShopping=0 />
                </b-col>
            </b-row>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import Beertable from './Beertable'
    import Pagefooter from './Pagefooter'
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        components: {
            Beertable,
            Pagefooter,
            Carousel,
            Slide,
        },

        computed: {
            ...mapState(['allExistingBeers']),
            checkZipLength(){
                if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.zip))
                    return true
                else return false
            },

        },

        data() {
            return {
                zip: '',
                beersList:[],
                brewersList:[],
                beersListLength:0,
                findingBeers:false,
                nothingFound:false,
            }
        },
        methods: {
            getbeers() {

            },
            viewBrewerProfile(brewer){
                var brewerId=brewer.uid
                var distbrewerid=''
                if(brewer.distbrewerid) distbrewerid=brewer.distbrewerid
                this.$router.push({ path: 'breweryprofile', query: { brewerId: brewerId, distbrewerid:distbrewerid }})
            },

            fetchBrewersList(){
                this.findingBeers = true
                this.beersList =[]
                this.brewersList = []

                //First find brewers that deliver to this zipcode
                fb.usersCollection.where('isbrewer','>=',1).where("counties", "array-contains", "San Diego").get().then(docs => {
                    docs.forEach(doc => {
                        var brewerData = doc.data()
                        var logoURL
                        if(brewerData.logoFileThumbnailURL) logoURL = brewerData.logoFileThumbnailURL
                        else logoURL = ''
                        var brewerObject = {uid: doc.id, company: brewerData.company, logoFileThumbnailURL:logoURL, email:brewerData.email}
                        this.brewersList.push(brewerObject) 
                        
                    })
                    })

                    .then(res => {
                        if (this.brewersList.length<=0 ) this.nothingFound = true
                        else this.nothingFound=false
                        this.findingBeers = false
                        function shuffleArray(array) {
                            for (let i = array.length - 1; i > 0; i--) {
                                const j = Math.floor(Math.random() * (i + 1));
                                [array[i], array[j]] = [array[j], array[i]];
                            }
                            return array
                        }
                        this.brewersList=shuffleArray(this.brewersList)

                        this.findBeers()
                        })
            },

            findBeers(){
                //Shuffle
                function shuffleArray(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                    return array
                }

                var containersList=["barrel1Quantity", "barrel2Quantity", "canQuantity", "bottleQuantity"]
                this.beersList =[]
                //Iterate over all containers
                var localBeersList=[]
                for (var j=0; j<containersList.length; j++){
                    var containerQuantity = containersList[j]
                    fb.beersCollection.where(containerQuantity, ">",0).get()
                    .then(docs => {
                        docs.forEach(doc => {
                            var theBeerData = doc.data()
                            theBeerData.docId = doc.id
                            const existingBeerindex = localBeersList.findIndex(item => item.id === theBeerData.id)
                            //localBeersList.push(theBeerData)
                            if (existingBeerindex<0&&theBeerData.state=="CA") localBeersList.push(theBeerData)
                        })
                        
                    })
                    .then(res => {
                        localBeersList=shuffleArray(localBeersList)
                        this.beersList=localBeersList
                        this.beersListLength = this.beersList.length
                        
                    })
                }

                    /*

                    fb.beersCollection.where('uid', '==', this.brewersList[i].uid).onSnapshot(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            //this.findingBeers = false
                            let theBeerData = doc.data()
                            theBeerData.docId = doc.id
                            var logoURL = 'https://res.cloudinary.com/lo4xxr5lr/image/upload/v1574513408/stock/beer.jpg'
                            var brewerEmail = ''
                            
                            //Get the logo
                            var brewersLength = this.brewersList.length;
                                for (var j = 0; j < brewersLength; j++) {
                                    if (this.brewersList[j].uid == theBeerData.uid) {
                                        if(this.brewersList[j].logoFileThumbnailURL){
                                            logoURL = this.brewersList[j].logoFileThumbnailURL
                                        } 
                                    break
                                    }
                                }
                            theBeerData.logoFileThumbnailURL =logoURL
                            this.beersList.push(theBeerData)
                            this.beersListLength = this.beersList.length
                            this.findingBeers = false
                        if (this.beersList.length<=0 ) this.nothingFound = true
                        else this.nothingFound=false

                        })
                    })
                    */


                
                this.findingBeers = false

                
            }
        },
        mounted(){
            this.fetchBrewersList()
        }
    }
</script>